import React from 'react'
import {BillingActivity, Transaction} from '../../types/app-types'
import TransactionList from '../common/TransactionList'
import LoaderInline from '../common/LoaderInline'
import AlertMessage from '../common/AlertMessage'
import {Link} from 'react-router-dom'
import {getNavigationPaths} from '../../services/navigation'
import {sortBy} from '../../services/utils'

interface AccountActivityCardProps {
  accountId: string
  billingActivityQuery: {
    data?: BillingActivity
    isLoading: boolean
  }
  className?: string
}

function getMostRecentTransactions(transactions: Transaction[]): Transaction[] {
  const sortedTxs = sortBy(transactions, 'date')
  return sortedTxs.slice(0, 10)
}

const AccountActivityCard = ({
  accountId,
  billingActivityQuery,
  className = ''
}: AccountActivityCardProps) => {
  const paths = getNavigationPaths(accountId)
  const isLoading = billingActivityQuery.isLoading
  const transactions = billingActivityQuery.data?.transactions || []
  const recentTransactions = getMostRecentTransactions(transactions)

  return (
    <div className={className}>
      <div className="card-default">
        <div className="card-body-default">
          <h1 className="card-header">Most Recent Activity</h1>
          {isLoading ? <LoaderInline /> : ''}

          {!isLoading && transactions.length ? (
            <TransactionList transactions={recentTransactions} />
          ) : (
            ''
          )}

          {!isLoading && !transactions.length ? (
            <AlertMessage type="info" message="No recent transactions found." />
          ) : (
            ''
          )}

          <div className="card-actions flex-none h-8 mt-4">
            <Link to={paths.Billing} className="link link-primary text-sm">
              View Billing
            </Link>
            <Link
              to={paths.PaymentHistory}
              className="link link-primary text-sm"
            >
              View Payments
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccountActivityCard
